import {
  Route,
  Routes,
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';
import './App.css';
// import { useAuth } from 'react-oidc-context';
import Welcome from './pages/welcome/Welcome';
import AuthCallback from './pages/AuthCallback';
import AuthFilter from './pages/AuthFilter';
import Workbench from './pages/workbench/Workbench';
import Translation from './pages/translation/Translation';
import TranslationDashboard from './pages/translation/TranslationDashboard';
import Success from './pages/payment/Success';
import PreviewGateway from './pages/translation/PreviewGateway';
import { LanguageProvider } from './pages/components/language';
import LandingPage from './pages/landing/LandingPage';

function App() {

  // const auth = useAuth()

  const workbench = <AuthFilter><Workbench></Workbench></AuthFilter>


  const router = createBrowserRouter([
    {
      path: "/",
      element: <LandingPage />,
    },
    {
      path: "/app",
      element: workbench,
      children: [
        {
          path: "",
          element: <TranslationDashboard/>
        },
        {
          path: "payment/success",
          element: <Success/>
        },
        {
          path: "preview",
          element: <PreviewGateway/>
        },
        {
          path: "dashboard",
          element: <TranslationDashboard/>
        },
        {
          path: "translation",
          element: <Translation/>
        }
      ],
    },
    {
      path: "/callback",
      element: <AuthCallback/>
    }

    // {
    //   path: "/workbench",
    //   element: <Workbench/>,
    //   children: [
    //     {
    //       path: "chatbot",
    //       element: <ChatbotV2 />
    //     },
    //     {
    //       id: 'clientmanagement',
    //       path: "clientmanagement/:clientId/:caseId/:module/:moduleId",
    //       element: <ClientManagement />,
    //       loader: ({params}) => {
    //         return {caseId: params['caseId'], clientId: params['clientId'], module: params['module'], moduleId: params['moduleId']}
    //       }
    //     },
    //     {
    //       path: "smarttools",
    //       element: <SmartTools />
    //     },
    //   ]
    // }
  ]);

  return (
    <LanguageProvider>
      <RouterProvider router={router} />
    </LanguageProvider>
  );
}

export default App;
